import axios from "axios"
import React, { useEffect, useState } from "react"
import Tab from "react-bootstrap/Tab"
import Tabs from "react-bootstrap/Tabs"
import Select from "react-select"
import MissingDataTable from "./MissingDataTable"
import TicketsTable from "./TicketsTable"
import InspectionVisitsTable from "./InspectionVisitsTable"
import { Input, Table, Row, Col } from "reactstrap"

import { useParams } from "react-router-dom"
import { unAuthUser } from "store/actions"
import { useDispatch } from "react-redux"
import UnAuthorizedPopup from "components/Common/UnAuthorized/UnAuthorizedPopup"
import { useSelector } from "react-redux"
import configs from "../../../config"

const { companyUuid } = configs.client
const TFI_BASE_URL = configs.tfiBaseUrl

const ProjectDetails = ({ sessionIndicator }) => {
  const [projectData, setProjectData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [noData, setNoData] = useState(false)

  let { authorized } = useSelector(state => ({
    authorized: state.Login.authorized,
  }))

  const params = useParams()

  const [searchType, setSearchType] = useState("ReferenceNo")
  const [searchValue, setSearchValue] = useState("")
  const dispatch = useDispatch()

  useEffect(() => {
    if (!searchValue) {
      setProjectData(null)
      setNoData(false)
      return
    }

    setLoading(true)
    axios
      .get(
        `${TFI_BASE_URL}/chatbot/project-info-m-t-v-data?${searchType}=${searchValue}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "company-uuid": companyUuid,
          },
        }
      )
      .then(res => {
        if (res.data?.success && res.data?.data) {
          setProjectData(res.data.data)
          setNoData(false)
        } else {
          setProjectData(null)
          setNoData(true)
        }
        setLoading(false)
      })
      .catch(err => {
        if (err?.response?.status === 401) {
          dispatch(unAuthUser())
        } else {
          console.log(err)
        }
        setProjectData(null)
        setNoData(true)
        setLoading(false)
      })
  }, [searchType, searchValue])

  useEffect(() => {
    setSearchType("ReferenceNo")
    setSearchValue("")
  }, [params.id])

  if (!authorized) {
    return <UnAuthorizedPopup />
  }

  const searchTypeOptions = [
    { value: "ReferenceNo", label: "Reference" },
    { value: "PolicyNo", label: "Policy" },
    { value: "RequestNo", label: "Request" },
    { value: "surveyResolutionNumber", label: "Survey" },
  ]

  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: "50px",
      borderColor: state.isFocused ? "#556ee6" : "#ced4da",
      boxShadow: state.isFocused
        ? "0 0 0 0.2rem rgba(85, 110, 230, 0.25)"
        : "none",
      "&:hover": {
        borderColor: "#556ee6",
      },
    }),
  }

  const selectedLabel =
    searchTypeOptions.find(opt => opt.value === searchType)?.label || "Search"

  return (
    <>
      <Row className="my-2">
        <Col md={4}>
          <Select
            isClearable={false}
            options={searchTypeOptions}
            value={searchTypeOptions.find(opt => opt.value === searchType)}
            onChange={selectedOption => {
              setSearchType(
                selectedOption ? selectedOption.value : "ReferenceNo"
              )
            }}
            styles={customSelectStyles}
            placeholder="Select Type..."
          />
        </Col>
        <Col md={8}>
          <Input
            className="rounded-pill ps-3"
            type="text"
            name="searchValue"
            value={searchValue}
            onChange={e => {
              setSearchValue(e.target.value)
            }}
            placeholder={`${selectedLabel} No ...`}
          />
        </Col>
      </Row>

      {noData ? (
        <div className="text-center">No project found</div>
      ) : loading ? (
        <div>Loading...</div>
      ) : projectData ? (
        <div>
          <div className="table-responsive my-2">
            <Table className="project-list-table table-nowrap text-center align-middle table-borderless">
              <thead>
                <tr>
                  <th>Reference No</th>
                  <th>Policy No</th>
                  <th>Request No</th>
                  <th>Survey Resolution No</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{projectData.project_info?.reference_number}</td>
                  <td>{projectData.project_info?.policy_number}</td>
                  <td>{projectData.project_info?.request_number}</td>
                  <td>{projectData.project_info?.servey_resolution_number}</td>
                </tr>
              </tbody>
            </Table>
          </div>

          <Tabs id="justify-tab-example" className="mb-3" justify fill>
            <Tab eventKey="missingData" title="Missing Data">
              <MissingDataTable data={projectData.missing_data} />
            </Tab>
            <Tab eventKey="tickets" title="Tickets">
              <TicketsTable tickets={projectData.tickets} />
            </Tab>
            <Tab eventKey="inspectionVisits" title="Inspection Visits">
              <InspectionVisitsTable
                sessionIndicator={sessionIndicator}
                visits={projectData.inspection_visits}
              />
            </Tab>
          </Tabs>
        </div>
      ) : (
        !loading &&
        !searchValue && (
          <div className="text-center text-muted">
            Enter a number to search for a project
          </div>
        )
      )}
    </>
  )
}

export default ProjectDetails
